import { styled } from '@material-ui/core';

export const FiltersContainer = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: 16,
	marginBottom: 24,
});

export const FilterBarContainer = styled('div')({
	'display': 'flex',
	'flexWrap': 'wrap',
	'gap': 12,
	'alignItems': 'center',

	'@media (max-width: 768px)': {
		flexDirection: 'column',
		alignItems: 'stretch',
	},
});

export const SearchWrapper = styled('div')({
	'position': 'relative',
	'flex': '1 1 300px',
	'minWidth': 200,
	'maxWidth': 400,

	'& .search-icon': {
		position: 'absolute',
		left: 14,
		top: '50%',
		transform: 'translateY(-50%)',
		color: 'var(--color-text-tertiary)',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
	},

	'& input': {
		width: '100%',
		height: 42,
		paddingLeft: 44,
		paddingRight: 18,
		borderRadius: 'var(--radius-full)',
		border: '1px solid var(--color-border-default)',
		backgroundColor: 'var(--color-bg-elevated)',
		color: 'var(--color-text-primary)',
		fontFamily: 'var(--font-family-regular)',
		fontSize: 'var(--text-body-size)',
		outline: 'none',
		transition: 'border-color var(--transition-fast), box-shadow var(--transition-fast)',
	},

	'@media (max-width: 768px)': {
		flex: '1 1 100%',
		maxWidth: 'none',
	},
});

export const QuickFiltersRow = styled('div')({
	'display': 'flex',
	'flexWrap': 'wrap',
	'gap': 10,
	'alignItems': 'center',

	'@media (max-width: 768px)': {
		width: '100%',
		justifyContent: 'space-between',
	},
});

// Multi-select dropdown container
export const MultiSelectContainer = styled('div')({
	position: 'relative',
	display: 'inline-block',
});

// Multi-select button - uses className 'open' instead of isopen prop
export const MultiSelectButton = styled('button')({
	'display': 'flex',
	'alignItems': 'center',
	'gap': 8,
	'padding': '8px 18px',
	'height': 42,
	'borderRadius': 'var(--radius-full)',
	'border': '1px solid var(--color-border-default)',
	'backgroundColor': 'var(--color-bg-elevated)',
	'color': 'var(--color-text-secondary)',
	'fontFamily': 'var(--font-family-medium)',
	'fontWeight': 500,
	'fontSize': 'var(--text-body-size)',
	'cursor': 'pointer',
	'transition': 'border-color var(--transition-fast), box-shadow var(--transition-fast)',

	'&:hover': {
		borderColor: 'var(--color-border-strong)',
	},

	'&.open': {
		borderColor: 'var(--color-border-focus)',
		boxShadow: '0 0 0 3px color-mix(in srgb, var(--color-brand-primary) 20%, transparent)',
	},

	'& .badge': {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		minWidth: 20,
		height: 20,
		padding: '0 6px',
		borderRadius: 10,
		backgroundColor: 'var(--color-brand-primary)',
		color: '#fff',
		fontSize: 11,
		fontFamily: 'var(--font-family-semibold)',
	},

	'& .chevron': {
		transition: 'transform var(--transition-fast)',
	},

	'&.open .chevron': {
		transform: 'rotate(180deg)',
	},
});

export const MultiSelectDropdown = styled('div')({
	'position': 'absolute',
	'top': 'calc(100% + 4px)',
	'left': 0,
	'minWidth': 220,
	'padding': '8px 0',
	'borderRadius': 'var(--radius-default)',
	'border': '1px solid var(--color-border-default)',
	'backgroundColor': 'var(--color-bg-elevated)',
	'boxShadow': 'var(--shadow-lg)',
	'zIndex': 100,
	'maxHeight': 320,
	'overflowY': 'auto',

	'& .dropdown-actions': {
		display: 'flex',
		gap: 8,
		padding: '8px 12px',
		borderTop: '1px solid var(--color-border-default)',
		marginTop: 4,
	},

	'& .dropdown-actions button': {
		flex: 1,
		padding: '6px 10px',
		borderRadius: 'var(--radius-sm)',
		border: 'none',
		backgroundColor: 'transparent',
		color: 'var(--color-brand-primary)',
		fontFamily: 'var(--font-family-medium)',
		fontSize: 'var(--text-caption-size)',
		cursor: 'pointer',
		transition: 'background-color var(--transition-fast)',
	},
});

export const CheckboxOption = styled('label')({
	'display': 'flex',
	'alignItems': 'center',
	'gap': 10,
	'padding': '8px 14px',
	'cursor': 'pointer',
	'transition': 'background-color var(--transition-fast)',

	'&:hover': {
		backgroundColor: 'var(--color-bg-hover)',
	},

	'& input[type="checkbox"]': {
		width: 16,
		height: 16,
		accentColor: 'var(--color-brand-primary)',
		cursor: 'pointer',
	},

	'& span': {
		fontFamily: 'var(--font-family-regular)',
		fontSize: 'var(--text-body-size)',
		color: 'var(--color-text-primary)',
	},
});

// Status filter pill group
export const StatusPillGroup = styled('div')({
	display: 'flex',
	gap: 0,
	borderRadius: 'var(--radius-full)',
	border: '1px solid var(--color-border-default)',
	backgroundColor: 'var(--color-bg-elevated)',
	overflow: 'hidden',
	height: 42,
});

// Status pill - uses className 'active' instead of isactive prop
export const StatusPill = styled('button')({
	'display': 'flex',
	'alignItems': 'center',
	'justifyContent': 'center',
	'padding': '0 14px',
	'height': '100%',
	'border': 'none',
	'borderRight': '1px solid var(--color-border-default)',
	'backgroundColor': 'transparent',
	'color': 'var(--color-text-secondary)',
	'fontFamily': 'var(--font-family-medium)',
	'fontSize': 'var(--text-body-size)',
	'cursor': 'pointer',
	'transition': 'all var(--transition-fast)',

	'&:last-child': {
		borderRight: 'none',
	},

	'&:hover': {
		backgroundColor: 'var(--color-bg-tertiary)',
		color: 'var(--color-text-primary)',
	},

	'&.active': {
		backgroundColor: 'var(--color-brand-primary)',
		color: '#fff',
	},

	'&.active:hover': {
		backgroundColor: 'var(--color-brand-primary)',
		color: '#fff',
	},
});

// More Filters button - uses className 'open' and 'has-filters' instead of props
export const MoreFiltersButton = styled('button')({
	'display': 'flex',
	'alignItems': 'center',
	'gap': 6,
	'padding': '8px 18px',
	'height': 42,
	'borderRadius': 'var(--radius-full)',
	'border': '1px solid var(--color-border-default)',
	'backgroundColor': 'var(--color-bg-elevated)',
	'color': 'var(--color-text-secondary)',
	'fontFamily': 'var(--font-family-medium)',
	'fontWeight': 500,
	'fontSize': 'var(--text-body-size)',
	'cursor': 'pointer',
	'transition': 'all var(--transition-fast)',

	'&:hover': {
		borderColor: 'var(--color-brand-primary)',
		backgroundColor: 'color-mix(in srgb, var(--color-brand-primary) 10%, transparent)',
	},

	'&.open': {
		borderColor: 'var(--color-border-focus)',
	},

	'&.has-filters': {
		borderColor: 'var(--color-brand-primary)',
		backgroundColor: 'color-mix(in srgb, var(--color-brand-primary) 10%, transparent)',
		color: 'var(--color-brand-primary)',
	},

	'& .badge': {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		minWidth: 18,
		height: 18,
		padding: '0 5px',
		borderRadius: 9,
		backgroundColor: 'var(--color-brand-primary)',
		color: '#fff',
		fontSize: 10,
		fontFamily: 'var(--font-family-semibold)',
	},

	'& .chevron': {
		transition: 'transform var(--transition-fast)',
	},

	'&.open .chevron': {
		transform: 'rotate(180deg)',
	},
});

// Active filters row
export const ActiveFiltersContainer = styled('div')({
	display: 'flex',
	flexWrap: 'wrap',
	gap: 8,
	alignItems: 'center',
	padding: '12px 16px',
	borderRadius: 'var(--radius-default)',
	backgroundColor: 'var(--color-bg-secondary)',
	border: '1px solid var(--color-border-default)',
});

export const FilterChip = styled('button')({
	'display': 'inline-flex',
	'alignItems': 'center',
	'gap': 6,
	'padding': '4px 10px 4px 12px',
	'borderRadius': 16,
	'border': '1px solid var(--color-border-default)',
	'backgroundColor': 'var(--color-bg-elevated)',
	'color': 'var(--color-text-primary)',
	'fontFamily': 'var(--font-family-medium)',
	'fontSize': 'var(--text-caption-size)',
	'cursor': 'pointer',
	'transition': 'all var(--transition-fast)',

	'&:hover': {
		borderColor: 'var(--color-error)',
		backgroundColor: 'var(--color-error-bg)',
	},

	'& .close-icon': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 16,
		height: 16,
		borderRadius: '50%',
		backgroundColor: 'var(--color-bg-tertiary)',
		color: 'var(--color-text-tertiary)',
		transition: 'all var(--transition-fast)',
	},
});

export const ClearAllButton = styled('button')({
	'marginLeft': 'auto',
	'padding': '4px 12px',
	'borderRadius': 'var(--radius-sm)',
	'border': 'none',
	'backgroundColor': 'transparent',
	'color': 'var(--color-error)',
	'fontFamily': 'var(--font-family-medium)',
	'fontSize': 'var(--text-caption-size)',
	'cursor': 'pointer',
	'transition': 'background-color var(--transition-fast)',

	'&:hover': {
		backgroundColor: 'var(--color-error-bg)',
	},
});

// Advanced filters panel - uses className 'open' instead of isopen prop
export const AdvancedFiltersPanel = styled('div')({
	'overflow': 'hidden',
	'maxHeight': 0,
	'opacity': 0,
	'transition': 'max-height 0.3s ease-in-out, opacity 0.2s ease-in-out, padding 0.3s ease-in-out',
	'padding': 0,
	'borderRadius': 'var(--radius-lg)',
	'border': 'none',
	'backgroundColor': 'var(--color-bg-secondary)',

	'&.open': {
		maxHeight: 500,
		opacity: 1,
		padding: 20,
		border: '1px solid var(--color-border-default)',
	},
});

export const AdvancedFiltersGrid = styled('div')({
	'display': 'grid',
	'gridTemplateColumns': 'repeat(auto-fit, minmax(200px, 1fr))',
	'gap': 16,
	'marginBottom': 20,

	'@media (max-width: 600px)': {
		gridTemplateColumns: '1fr',
	},
});

export const FilterField = styled('div')({
	'display': 'flex',
	'flexDirection': 'column',
	'gap': 6,

	'& label': {
		fontFamily: 'var(--font-family-medium)',
		fontSize: 'var(--text-caption-size)',
		color: 'var(--color-text-secondary)',
	},

	'& input, & select': {
		height: 40,
		padding: '0 12px',
		borderRadius: 'var(--radius-default)',
		border: '1px solid var(--color-border-default)',
		backgroundColor: 'var(--color-bg-primary)',
		color: 'var(--color-text-primary)',
		fontFamily: 'var(--font-family-regular)',
		fontSize: 'var(--text-body-size)',
		outline: 'none',
		transition: 'border-color var(--transition-fast), box-shadow var(--transition-fast)',
	},

	'& select': {
		cursor: 'pointer',
		appearance: 'none',
		backgroundImage:
			"url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'right 12px center',
		paddingRight: 36,
	},
});

export const AdvancedFiltersActions = styled('div')({
	'display': 'flex',
	'gap': 12,
	'justifyContent': 'flex-end',

	'@media (max-width: 480px)': {
		flexDirection: 'column',
	},
});

// Action button - uses className 'primary' instead of variant prop
export const ActionButton = styled('button')({
	'padding': '10px 20px',
	'borderRadius': 'var(--radius-default)',
	'border': '1px solid var(--color-border-default)',
	'backgroundColor': 'var(--color-bg-primary)',
	'color': 'var(--color-text-primary)',
	'fontFamily': 'var(--font-family-medium)',
	'fontSize': 'var(--text-body-size)',
	'cursor': 'pointer',
	'transition': 'all var(--transition-fast)',

	'&:hover': {
		backgroundColor: 'var(--color-bg-hover)',
	},

	'&.primary': {
		border: 'none',
		backgroundColor: 'var(--color-brand-primary)',
		color: '#fff',
	},

	'&.primary:hover': {
		backgroundColor: 'var(--color-brand-primary-hover, #255e38)',
	},

	'@media (max-width: 480px)': {
		width: '100%',
	},
});

export const FiltersLabel = styled('span')({
	fontFamily: 'var(--font-family-medium)',
	fontSize: 'var(--text-caption-size)',
	color: 'var(--color-text-tertiary)',
	marginRight: 4,
});
